export const DETECTING_OUT_OF_STOCK_PENDING = "DETECTING_OUT_OF_STOCK_PENDING";
export const DETECTING_OUT_OF_STOCK_REJECTED = "DETECTING_OUT_OF_STOCK_REJECTED";
export const DETECTING_OUT_OF_STOCK_FULFILLED = "DETECTING_OUT_OF_STOCK_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/detectingOutOfStock.js